export default "/_next/static/chunks/fonts/Lora-Regular-latin-fab14c273f01f91d3c0e5ef18688cf00.woff2";